var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-popover',{attrs:{"placement":_vm.tooltipPlacement,"trigger":"hover","offset":"16"}},[_c('img',{staticClass:"tooltip-target",style:(_vm.imgStyle),attrs:{"src":_vm.imgSrc,"alt":""}}),_c('template',{slot:"popover"},[_c('p',[_vm._v(_vm._s(_vm.tooltipContent))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }